module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#comment",
      toString: function () {
        return this.url;
      }
    }